import { render, staticRenderFns } from "./VideoPlay.vue?vue&type=template&id=6510804e&scoped=true&"
import script from "./VideoPlay.vue?vue&type=script&lang=js&"
export * from "./VideoPlay.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlay.vue?vue&type=style&index=0&id=6510804e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6510804e",
  null
  
)

export default component.exports